module.exports = __webpack_public_path__ + "img/location.db1ea6b9.svg";